













































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class WidgetNews extends Vue {
  $refs !: {
    textContainer: HTMLDivElement,
  }

  @Prop({ default: false }) dark!: boolean
  news: string = 'بی خبری ، خوش خبری'
  agency: string = ''
  rssList: string[] = ['tasnim', 'mehr', 'irna', 'varzesh3']
  url: string = '#'

  mounted() {
    this.fetchNews()
  }

  async fetchNews() {
    let token = '816840:640586f79541b'
    let rss = this.rssList[this.randomInt(this.rssList.length)]
    let data = await fetch(`https://one-api.ir/rss/?token=${token}&action=${rss}`) //https://panel.one-api.ir/
    let text = await data.json()
    let randInt = this.randomInt(text['result']['item'].length)
    this.news = text['result']['item'][randInt]['title']
    this.url = text['result']['item'][randInt]['link']
    this.agency = text['result']['title'].split('|')[0]
  }

  randomInt(max) {
    return Math.floor(Math.random() * max)
  }

}

